//import _ from 'lodash';

import store from '~system/vuex';

export default{

  /**
   * Converts value to a string. An empty string is returned for null and undefined values.
   * The sign of -0 is preserved.
   * number 타입 혹은 number형 string을 문자열로 반환한다.
   *
   * @function toCharNum
   * @param  {number|string} num
   * @return  {string}
   */
  //toCharNum : (num) => _.toString(num),
  toCharNum : (num) => _.toString(num),

  /**
   * 값이 정수인지 판단하여 true/false 를 반환한다.
   *
   * @function isInteger
   * @param  {number} num
   * @return  {boolean}
   */
  isInteger : (num) => num === parseInt(num, 10),

  /**
   * 값이 float인지 판단하여 true/false 를 반환한다.
   *
   * @function isFloat
   * @param  {number} num
   * @return  {boolean}
   */
  isFloat : (num) => num !== Infinity && num === +num && num !== (num|0),

  /**
   * 수를 한글 금액으로 변환
   * @param value
   * @returns {string}
   */
  numberToHangul : (value) => {
    let num = value.toString();
    const hanA = new Array("", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구", "십");
    const danA = new Array("", "십", "백", "천", "", "십", "백", "천", "", "십", "백", "천", "", "십", "백", "천");
    let result = "";
    for (let i = 0; i < num.length; i++) {
      let str = "";
      let han = hanA[num.charAt(num.length - (i + 1))];
      if (han != "") str += han + danA[i];
      if (i == 4) str += "만";
      if (i == 8) str += "억";
      if (i == 12) str += "조";
      result = str + result;
    }
    if (num != 0)
      result = result + "원";
    return result;
  },

  numberWithCommas : (number, comma = ',') => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, comma);
  },

  onlyNums : (text, preventContininuousZeroStart) => {
    let ret = '';
    let number = '';
    let isNoneZero = false;
    const mask = {
      test: char => char.match(/[0-9]/),
      convert: char => char,
    };
    for (let i = 0; i < text.length; i += 1) {        
      if (mask.test(text[i])) { number += text[i]; }
    }
    for (let i = 0; i < number.length; i += 1) {
      if (number[i] !== '0') {
        isNoneZero = true;
      }
      if (i > 0 && preventContininuousZeroStart) {
        if (isNoneZero) {
          ret += number[i];
        }
      } else {
        ret += number[i];
      }      
    }
    return ret;
  },

  getCurrencyFormattedValue : (inputValue) => {
    let decimal = '.';
    if (store.getters.userInfo && store.getters.userInfo.digitGroupType) {
      decimal = store.getters.userInfo.digitGroupType.substr(5,1);
    }
    return inputValue.replace(/\./g, `${decimal}`);
  },

  getCurrencyInfoFromText : (inputValue, digitGroupType, decimalLength = 3) => {
    let decimal = '.';
    let comma = ",";    
    if (digitGroupType) {
      comma = digitGroupType.substr(1,1);
      decimal = digitGroupType.substr(5,1);
    } else if (store.getters.userInfo && store.getters.userInfo.digitGroupType) {
      comma = store.getters.userInfo.digitGroupType.substr(1,1);
      decimal = store.getters.userInfo.digitGroupType.substr(5,1);
    }
    const hasDecimal = (inputValue.indexOf(decimal) >= 0) ? true : false;

    let sign = '';
    if (inputValue[0] === '-') { // 부호 체크
      sign = inputValue[0];
    }

    const splittedValue = inputValue.split(decimal);
    const decimalValue = splittedValue[0];
    let decimalNumber = utils.onlyNums(decimalValue, true);
    let pointNumber = '';
    if (splittedValue.length > 1) {
      pointNumber = splittedValue[1].substring(0, decimalLength);
    }
    pointNumber = utils.onlyNums(pointNumber);
    decimalNumber = sign + decimalNumber;    
    decimalNumber = (decimalNumber.length <= 2 && isNaN(parseInt(decimalNumber)))? '' : parseInt(decimalNumber);

    let decimalText = '';
    if (decimalNumber !== '') {
      decimalText = utils.numberWithCommas(Math.abs(decimalNumber), comma);
    }

    if (sign && decimalNumber === 0) {
      
    }

    let value = hasDecimal ? `${decimalNumber}.${pointNumber}` : `${decimalNumber}`;

    if (decimalNumber === 0 && hasDecimal && sign) { // -0. -> 0으로 나오는것 방지
      value = `${sign}${decimalNumber}.${pointNumber}`;
      // value = hasDecimal ? `${sign}${decimalNumber}.${pointNumber}` : `${sign}${decimalNumber}`;
    }

    const text = (hasDecimal && decimalNumber !== '') ? `${sign}${decimalText}${decimal}${pointNumber}` : `${sign}${decimalText}`;
    return {
      value,
      text,
    }
  }

  // /**
  //  * 두 개의 값이 동일한지 아닌지 심층(?) 비교를 수행하여 true/false 를 반환한다.
  //  * Note: arrays, array buffers, booleans, date objects, error objects, maps,
  //  * numbers, Object objects, regexes, sets, strings, symbols, and typed arrays.
  //  *
  //  * 오브젝트는 상속받지 않은 자신만의 열거형 프라퍼티를 비교한다.
  //  * 펑션과 DOM 노드는 strict equality( 즉, ===)로 비교한다.
  //  *
  //  * @function isEqual
  //  * @param  {number} num1
  //  * @param  {number} num2
  //  * @return  {boolean}
  //  */
  // isEqual : (num1, num2) => _.isEqual(num1, num2),

}
